webpackJsonp([23419474955521],{

/***/ 423:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/blog/test.md absPath of file >>> MarkdownRemark","html":"<p>test</p>","fields":{"slug":"/blog/test/"},"frontmatter":{"date":"April 06, 2018","title":"test","cover":"/img/coffee-gear.png","meta_title":"test","meta_description":"test","tags":["test"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/blog/test.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-test-85403365721b93fbe2d4.js